import toast from "react-hot-toast";
import {useHistory} from "react-router";
import {IonCol, IonRow} from "@ionic/react";
import {useContext, useEffect, useState} from "react";
import {useLazyQuery, useMutation, useQuery} from "@apollo/client";

import {Breadcrumbs} from "../../../components";
import {AuthContext} from "../../../context/AuthContext";

//
import {GET_MY_AGENCY} from "../../../graphql/queries/common.query";
import {
  CREATE_MY_ORDER_MUTATION,
  UPDATE_MY_ORDER_MUTATION,
} from "../../../graphql/mutations/services.mutation";
import {
  GET_ALL_MY_PENDING_ORDERS,
  GET_MY_SINGLE_ORDER,
} from "../../../graphql/queries/myorder.query";

//
import Intestatario from "./intestatario";
import PrivacyPolicy from "./PrivacyPolicy";
import {isAuthenticated} from "../../../lib/utils/auth.utils";
import {isDateExpired} from "../../../lib/utils/date-checker";

//

export default function Carrello({formFields}: {formFields: any}) {
  const {user, removeServiceFromCart, cartList} = useContext(AuthContext);
  const history = useHistory();

  const historySearch = history?.location?.search;
  const urlParams = new URLSearchParams(historySearch);

  const [orderId, masterId] = [
    urlParams.get("orderId"),
    urlParams.get("masterId"),
  ];

  const breadcrumbEntries = [
    {title: "Area personale", link: "/personale"},
    {title: "Carrello"},
  ];

  const [updateMyOrderMutation] = useMutation(UPDATE_MY_ORDER_MUTATION);
  const [createMyOrderMutation] = useMutation(CREATE_MY_ORDER_MUTATION);

  const [step, setStep] = useState(0);
  const [privacyView, setPrivacyView] = useState(false);

  const [data, setData] = useState<any>({});
  const [order, setOrder] = useState<any>({});

  const [agencyDetails, setAgencyDetails] = useState<any>({});

  const [formValues, setFormValues] = useState<any>({});

  const stepSubmit = (input: any) => {
    console.log(input, "input");
    if (step < 1) setStep(step + 1);
    setData({...data, ...input});
    setPrivacyView(true);
  };

  if (isAuthenticated()) {
    useQuery(GET_MY_AGENCY, {
      fetchPolicy: "cache-and-network",
      onCompleted: (data) => {
        setAgencyDetails(data.getMyAgency);
      },
    });
  }

  const [getMasterOrder] = useLazyQuery(GET_MY_SINGLE_ORDER, {
    fetchPolicy: "cache-and-network",
    onCompleted: (data) => {
      const info = data.getMyOrderDetail.data;
      if (!info) return;

      const values: any = {
        accountHolder: info.accountHolder,
        billTo: info.billTo,
        note: info.note,
      };

      Object.entries(info.billingAddress).forEach(([objKey, objVal]) => {
        values[`billingAddress.${objKey}`] = objVal;
      });

      setFormValues(values);
    },
  });

  const [getSingleOrder] = useLazyQuery(GET_MY_SINGLE_ORDER, {
    fetchPolicy: "cache-and-network",
    onCompleted(data) {
      const info = data.getMyOrderDetail.data;
      if (!info) return;

      setOrder(info);
    },
  });

  const [getAllMyPendingOrders] = useLazyQuery(GET_ALL_MY_PENDING_ORDERS, {
    fetchPolicy: "cache-and-network",
    onCompleted(data) {
      setOrder(data.getAllMyOrders.data[0]);
    },
  });

  const updateData = () => {
    const formattedServices = order?.orderedService.map((service: any) => ({
      id: service.id,
      orderId: order.id,
      serviceId: service.service.id,
      fields:
        service?.fields?.map((field: any) => {
          let dataVsDocuments = {};

          if (field.documents.length > 0) {
            dataVsDocuments = {
              documents: field?.documents,
            };
          } else {
            dataVsDocuments = {
              data: {
                name: field?.data?.name,
                value: field?.data?.value,
              },
            };
          }

          return {
            fieldId: field?.fieldId,
            cluster: field?.cluster,
            ...dataVsDocuments,
          };
        }) ?? [],
    }));

    updateMyOrderMutation({
      variables: {
        id: order.id,
        services: formattedServices,
        agencyId: user?.agencyId,
        accountHolder: data.accountHolder,
        billTo: data.billTo,
        billingAddress: {
          ...(data.billTo === "client" ? {} : data.billingAddress),
          id: order.billingAddress.id,
        },
        note: data.note,
        isTermsAndConditionAccepted: true,
      },
    })
      .then(() => {
        history.push("/personale");
        toast.success(
          'Complimenti! La sua pratica è stata inviata ai nostri operatori, può vederla nella sezione "Le mie pratiche".'
        );
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const createData = () => {
    const formattedServices = formFields?.services.map((service: any) => ({
      id: service.id,
      orderId: service.id,
      serviceId: service.serviceId,
      fields:
        service.fields?.map((field: any) => {
          let dataVsDocuments = {};

          if (field.documents.length > 0) {
            dataVsDocuments = {
              documents: field?.documents,
            };
          } else {
            dataVsDocuments = {
              data: {
                name: field?.data?.name,
                value: field?.data?.value,
              },
            };
          }

          return {
            fieldId: field?.fieldId,
            cluster: field?.cluster,
            ...dataVsDocuments,
          };
        }) ?? [],
    }));
    createMyOrderMutation({
      variables: {
        services: formattedServices,
        agencyId: data?.agencyId || formFields?.agencyId,
        accountHolder: data.accountHolder || formFields?.accountHolder,
        billTo: data.billTo,
        billingAddress: {
          ...(data.billTo === "client" ? {} : data.billingAddress),
          // id: data.billingAddress.id,
        },
        note: data.note,
        isTermsAndConditionAccepted: true,
      },
    })
      .then(() => {
        cartList.forEach((item: any) => {
          removeServiceFromCart(item.cartId);
        });
        history.push("/personale");
        toast.success(
          'Complimenti! La sua pratica è stata inviata ai nostri operatori, può vederla nella sezione "Le mie pratiche".'
        );
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  useEffect(() => {
    if (orderId && masterId) {
      Promise.all([
        getSingleOrder({
          variables: {id: parseInt(orderId)},
        }),
        getMasterOrder({
          variables: {id: parseInt(masterId)},
        }),
      ]);
    } else {
      getAllMyPendingOrders();
    }
  }, []);

  useEffect(() => {
    if (formFields) {
      console.log(formFields, "form fields");
    }
  }, [formFields]);

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      {order ? (
        <>
          {isDateExpired(agencyDetails?.client?.expiresAt) && (
            <IonRow>
              <IonCol>
                <span style={{color: "red", fontWeight: "bold"}}>
                  Attenzione, il documento di identità risulta essere scaduto.
                  Aggiornalo al piu presto nel tuo profilo personale
                </span>
              </IonCol>
            </IonRow>
          )}
          <Intestatario
            stepSubmit={stepSubmit}
            initialValues={formValues}
            orderData={order}
            formFields={formFields}
          />
        </>
      ) : formFields ? (
        <>
          {isDateExpired(agencyDetails?.client?.expiresAt) && (
            <IonRow>
              <IonCol>
                <span style={{color: "red", fontWeight: "bold"}}>
                  Attenzione, il documento di identità risulta essere scaduto.
                  Aggiornalo al piu presto nel tuo profilo personale
                </span>
              </IonCol>
            </IonRow>
          )}
          <Intestatario
            stepSubmit={stepSubmit}
            initialValues={formValues}
            orderData={order}
            formFields={formFields}
          />
        </>
      ) : (
        <div className="attesa-no-service-text">Nessun ordine in sospeso!</div>
      )}

      <PrivacyPolicy
        visible={privacyView}
        dismiss={() => setPrivacyView(false)}
        submitForm={formFields ? createData : updateData}
      />
    </div>
  );
}
